import React, { type ComponentProps, type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';
import Toggle from '@atlaskit/toggle';

import { useIsDisabledContext } from '../../controllers/disabled-context';

type ToggleFieldProps = {
	label: string;
	Icon?: ReactNode;
	isDisabled?: boolean;
} & ComponentProps<typeof Toggle>;

const toggleFieldContainerDisabledStyles = xcss({
	color: 'color.text.disabled',
});

const labelWrapperStyles = xcss({ alignItems: 'center', flexGrow: 1, gap: 'space.100' });

export const ToggleField = ({ Icon, id, label, isDisabled, ...toggleProps }: ToggleFieldProps) => {
	const isDisabledContext = useIsDisabledContext();
	const isToggleDisabled = isDisabled ?? isDisabledContext;

	if (!id) {
		id = `toggle-${label.replace(/\s+/g, '-').toLowerCase()}-property`;
	}

	return (
		<Flex alignItems="center" xcss={isToggleDisabled && toggleFieldContainerDisabledStyles}>
			<Flex xcss={labelWrapperStyles}>
				<label htmlFor={id}>{label}</label>
				{Icon}
			</Flex>
			<Toggle {...toggleProps} isDisabled={isToggleDisabled} id={id} />
		</Flex>
	);
};
